import Scoreapis  from "../../api/score";
import ScoreModel from "../Score/index.vue";
export default {
    name: "ScoreList",
    components: {
      ScoreModel,
    },
    data() {
        return {
            detailVisible:false,
            dataDetail:{},
            userList:[],
            type:"",
            query: {
                keyword: "",
                type:"1",
                pageIndex: 1,
                pageSize: 10
            },
            tableCols:[
                {
                    "prop": "UserName",
                    "label": "姓名",
                    "width": "100",
                    "align": "center"
                },
                {
                  "prop": "IdCard",
                  "label": "身份证号",
                  "width": "200",
                  "align": "center"
              },
                {
                    "prop": "CompanyName",
                    "label": "公司名称",
                    "width": "",
                    "align": "center"
                },
                {
                  "prop": "UpdateUserName",
                  "label": "操作人",
                  "width": "100",
                  "align": "center"
                },
                {
                  "prop": "Score",
                  "label": "综合评分",
                  "width": "100",
                  "align": "center"
                },
                {
                  "prop": "PreCredit",
                  "label": "预授信(万)",
                  "width": "100",
                  "align": "center"
                },
                {
                  "prop": "Type",
                  "label": "类型",
                  "width": "100",
                  "align": "center"
                },
                {
                    "prop": "UpdateTime",
                    "label": "更新时间",
                    "width": "160",
                    "align": "center"
                },
                {
                    "prop": "Operation",
                    "label": "操作",
                    "width": "240",
                    "align": "center"
                }
            ],
            tableData:[],
            pageTotal: 0,
            scrollHeight:400,
            tel:""
        };
    },
    beforeCreate: function () {
      let meta = this.$route.meta
      if(meta&&meta.permBtns.length>0){
        this.permBtns = meta.permBtns
      }
  },
    created() {
      this.getData();
    },
    mounted() {
      let that = this;
      that.calcTableHeight();
      // 注：window.onresize只能在项目内触发1次
      window.onresize = function windowResize () {
        that.calcTableHeight();
      }
    },
    // watch: {
    //   dataDetail: {
    //     handler(newVal) {
    //       this.tel=newVal.UserID
    //       var userList=this.userList;
    //       for(var i=0;i<userList.length;i++)
    //       if(userList[i].UserID==newVal.UserID){
    //         var tel=userList[i].Tel;
    //         this.tel=tel;
    //       }
    //      },
    //      deep: true,
    //   }
    // },
    methods: {
        getData(){
          let param=this.query;
          Scoreapis.getScoreList(param).then(res => {
                            this.$data.tableData=res.list;
                            this.$data.pageTotal=res.count
                    });
    
      },
      AddSucess(){
        this.getData();
      },
      selectUser(){
      var UserID=this.dataDetail.UserID;
      if(UserID==''){
        this.tel="";return;
      }
      var userList=this.userList;
          for(var i=0;i<userList.length;i++)
          if(userList[i].UserID==UserID){
            var tel=userList[i].Tel;
            this.tel=tel;
          }
      },
      getScoreById(){
          let param={
            ScoreId: "1"
          };
         Scoreapis.getScoreById(param).then(res => {
                            this.$data.form=res;
                    });
      },
      addOrUpdateScore(){
          let param=this.$data.dataDetail;
          if(param.UserName==""){
            this.$message.error("姓名不能为空");
            return;
          }
          if(this.type=="add")this.addScore(param);
          else this.updateScore(param);
      
      },
      addScore(param){
        Scoreapis.addScore(param).then(res => {
          if(res){
           this.$message.success("新增成功");
             this.getData();
             this.$data.detailVisible=false;
          }else{
            this.$message.error("新增失败");
          }
      });
      },
       updateScore(param){
         Scoreapis.updateScore(param).then(res => {
                        if(res){
                         this.$message.success("修改成功");
                           this.getData();
                           this.$data.detailVisible=false;
                        }else{
                          this.$message.error("修改失败");
                        }
                    });
      },
        // 触发搜索按钮
        refreshList() {
            this.query.pageIndex = 1;
            this.getData();
        },
        getUserList(user){
          let param={
            type:"0",
            keyword:""
          }
          Scoreapis.getUserListByMenuId(param).then(res => {
            if(user)res.push(user);
            this.userList=res;
        });
        },
        handleEmpty(){
           this.$data.query={
            keyword: "",
            pageIndex: 1,
            pageSize: 10}
        },
        handleAdd(){
          var that=this;
          that.$refs.ScoreModel.onChangeOpen()
          that.$refs.ScoreModel.queryData({},"add")
          // this.$data.detailVisible=true;
          // this.dataDetail={
          //   UserName:"",
          // }
          // this.type="add";
        },
        handleUpdate(index, row){
          var that=this;
          that.$refs.ScoreModel.onChangeOpen()
          // that.$refs.ScoreModel.queryData(row,"update")
          that.$refs.ScoreModel.queryData(row,"info")
          // this.dataDetail={
          //   UserName:row.UserName,
          //   Id:row.Id,
          // }
          // this.type="update";
          // this.$data.detailVisible=true;
        },
        // 删除操作
        handleDelete(index, row) {
            let that = this;
            if(row){
                that.$confirm('确定删除吗, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                  let param={
                    Id:row.Id
                  };
                 Scoreapis.deleteScore(param).then(res => {
                                if(res){
                                  that.$message.success("删除成功");
                                  that.getData();
                                }else{
                                  that.$message.error("删除失败");
                                }
                            });
                }).catch(() => {
                  that.$message({
                      type: 'info',
                      message: '已取消删除'
                    });
                });
            }
        },
        // 分页导航
        handlePageChange(val) {
            this.query.pageIndex = val;
            this.getData();
        },
        handleSizeChange(val){
            this.query.pageIndex = 1;
            this.query.pageSize = val;
            this.getData();
        },
        calcTableHeight(){
          this.$nextTick(() => {
            var height1=$(".content-box .content").height();
            var height2=$(".content-box .content .seach-container").height();
            var height=height1-height2-112-40;
            this.scrollHeight = height;
          });
        }
    },
  
  };
